import { CircularProgress } from "@mui/material";
import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";

import { useGetProductById } from "../../services/use-product-api";

type ProductWidgetProps = {
    productId: number;
};

function ProductWidget(props: ProductWidgetProps) {
    const { loading, data, error } = useGetProductById(props.productId);

    return (
        <>
            {loading && <CircularProgress size={"1rem"} aria-busy="true" />}
            {error && <SentimentVeryDissatisfiedIcon aria-label="icon" />}
            {data && (
                <span>
                    {data.sku} : {data.description}
                </span>
            )}
        </>
    );
}

export default ProductWidget;
